module.exports = __webpack_public_path__ + "static/media/time-left.01438215.svg";